module.exports = __webpack_public_path__ + "img/sync-red.5204be01.svg";